import { SvgIcon, SvgIconProps } from '@mui/material';

const InfoFillIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 28, height: 28, fill: props.fill, ...props.sx }}
      data-testid="infoIcon"
      titleAccess="information"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3332 13.9998C27.3332 21.3636 21.3636 27.3332 13.9998 27.3332C6.63604 27.3332 0.666504 21.3636 0.666504 13.9998C0.666504 6.63604 6.63604 0.666504 13.9998 0.666504C21.3636 0.666504 27.3332 6.63604 27.3332 13.9998ZM15.9998 7.99984C15.9998 9.10441 15.1044 9.99984 13.9998 9.99984C12.8953 9.99984 11.9998 9.10441 11.9998 7.99984C11.9998 6.89527 12.8953 5.99984 13.9998 5.99984C15.1044 5.99984 15.9998 6.89527 15.9998 7.99984ZM11.9998 14.6665C11.9998 13.5619 12.8953 12.6665 13.9998 12.6665C15.1044 12.6665 15.9998 13.5619 15.9998 14.6665V19.9998C15.9998 21.1044 15.1044 21.9998 13.9998 21.9998C12.8953 21.9998 11.9998 21.1044 11.9998 19.9998V14.6665Z"
        fill="inherit"
      />
    </SvgIcon>
  );
};

export default InfoFillIcon;
